import { useLocation, Link } from 'react-router-dom';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { FileQuestion, Home, LayoutDashboard } from 'lucide-react';
import { createLogger } from '@/lib/logger';

const log = createLogger('NotFound');

const NotFound = () => {
  const location = useLocation();
  const { t } = useTranslation();

  useEffect(() => {
    log.warn('user hit a non-existent route', { path: location.pathname });
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted/40 px-4">
      <div className="w-full max-w-md text-center space-y-6">
        {/* Icon */}
        <div className="mx-auto flex h-24 w-24 items-center justify-center rounded-full bg-primary/10">
          <FileQuestion className="h-12 w-12 text-primary" />
        </div>

        {/* Heading */}
        <div className="space-y-2">
          <h1 className="text-6xl font-bold tracking-tight text-primary">404</h1>
          <h2 className="text-xl font-semibold text-foreground">{t('notFound.title')}</h2>
          <p className="text-sm text-muted-foreground leading-relaxed">{t('notFound.body')}</p>
        </div>

        {/* Attempted path */}
        <div className="rounded-lg border bg-background px-4 py-3">
          <p className="text-xs text-muted-foreground mb-1">{t('notFound.requestedPath')}</p>
          <code className="text-sm font-mono text-foreground break-all">
            {location.pathname}
          </code>
        </div>

        {/* Action buttons */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button asChild className="bg-primary hover:bg-primary/90 text-white">
            <Link to="/dashboard">
              <LayoutDashboard className="w-4 h-4 mr-2" />
              {t('notFound.backToDashboard')}
            </Link>
          </Button>
          <Button asChild variant="outline">
            <Link to="/">
              <Home className="w-4 h-4 mr-2" />
              {t('notFound.backToHome')}
            </Link>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
